<template>
    <app-table
            deletable
            :data="getItems"
            :page-size="params.limit"
            :highlight-rows-on-hover="true"
            @deleteRow="deleteItem"
    >
        <template slot="secondary_header">
            <synonyms-search-bar :params="params" :item="item"/>
        </template>
        <app-table-column first attribute="name" :label="translations.name"/>
        <template slot="footer" v-if="filteredItems && filteredItems.length > params.limit">
            <app-table-pagination
                    :page="listPage"
                    :itemsPerPage="params.limit"
                    :totalCount="filteredItems.length"
                    @pageChanged="tablePageChanged"
            />
        </template>
    </app-table>
</template>

<script>
import SynonymsSearchBar from 'components/Languages/SynonymsSearchBar.vue'
import { mapActions } from 'vuex'

export default {
  name: 'synonyms',
  components: {
    SynonymsSearchBar
  },
  data() {
    return {
      listPage: 1,
      params: {
        search: '',
        offset: 0,
        limit: 30,
        show: this.$route.params.id
      }
    }
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  methods: {
    ...mapActions([
      'updateLanguage'
    ]),
    async deleteItem(item) {
      const obj = { ...this.item }
      this.items.splice(this.items.indexOf(item), 1)
      obj.synonyms = this.items.map(v => v.name)
      const response = await this.updateLanguage({
        params: {
          id: this.item._id
        },
        data: obj
      }).catch(err => err.response)
      this.handleResponseIfError(response)
    },
    handleResponseIfError(response) {
      if (response.status === 500) {
        this.appShowErrors([this.errorTrans.serverError])
      }

      this.apiErrors = response.data.error
      if (this.apiErrors && this.apiErrors.length) {
        this.mapApiErrorsToErrors()

        if (response.status === 422) {
          this.appShowErrors([this.errorTrans.formError])
        }
      }
    },
    tablePageChanged(page) {
      window.scrollTo(0, 0)
      this.listPage = page
      this.params.offset = (this.listPage - 1) * this.params.limit
    },
    search(element) {
      this.listPage = 1
      this.params.offset = 0
      return element.name.toLowerCase().includes(this.params.search.trim().toLowerCase())
    }
  },
  computed: {
    translations() {
      return {
        name: this.$gettext('Název')
      }
    },
    items() {
      if (!this.item.synonyms) {
        return null
      }
      const retVal = []
      for (let i = 0; i < this.item.synonyms.length; i++) {
        retVal.push({
          name: this.item.synonyms[i]
        })
      }
      return retVal
    },
    filteredItems() {
      if (this.items) {
        return [...this.items].filter(this.search)
      }
      return null
    },
    getItems() {
      if (this.filteredItems) {
        return [...this.filteredItems].splice(this.params.offset, this.params.limit)
      }

      return []
    }
  }
}
</script>
